"use client";

import React from "react";

import ErrorPage from "../../molecules/ErrorPage/ErrorPage.component";

const SERVER_ERROR_CONTENT = {
  title: "Ops... qualcosa è andato storto",
  image: {
    src: "/masks/500.svg",
    get alt() {
      return SERVER_ERROR_CONTENT.title;
    },
  },
};

const ServerError: React.FC = () => {
  return (
    <ErrorPage
      title={SERVER_ERROR_CONTENT.title}
      image={SERVER_ERROR_CONTENT.image}
    />
  );
};

export default ServerError;
